export class DeviceTraccar {
    id?: number;
    name: string;
    uniqueId: string;
    status: string;
    disabled: boolean;
    lastUpdate: Date;
    positionId: number;
    groupId: number;
    phone: string;
    model: string;
    contact: string;
    category: string;
    attributes: {
        companyId?: number;
        userId: number;
        equipmentId: number;
        speedLimit?: number;
    };
    totalDistance?: number;
}

export class DeviceAccumulators {
    totalDistance: number;
    hours: number;
}

export class DeviceForm {
    id?:number
    userId: number
    name: string
    uniqueId: string
    equipmentId:number
    phone: string
    model: string
    speedLimit?: number
    totalDistance?: number
}